/**
 * チュートリアル関連の定数
 */

/** チュートリアルID（completedTutorials リストで使用） */
export const TUTORIAL_IDS = {
  /** 初回ウェルカムストーリー */
  WELCOME: 'welcome',
  /**
   * イベント作成ページ: AI企画ボタン紹介（廃止予定）
   *
   * `CREATE_EVENT_TOUR` に統合済み。過去に完了済みのユーザーは
   * `CREATE_EVENT_TOUR` も完了扱いとして起動しない（マイグレーション）。
   */
  CREATE_EVENT_AI: 'create_event_ai',
  /** イベント作成ページ: 全体ガイドツアー（AI→候補日→タイトル→...→保存） */
  CREATE_EVENT_TOUR: 'create_event_tour',
  /** ページガイド: ダッシュボード */
  PAGE_DASHBOARD: 'page_dashboard',
  /** ページガイド: イベント一覧 */
  PAGE_EVENTS: 'page_events',
  /** ページガイド: イベント詳細 */
  PAGE_EVENT_DETAIL: 'page_event_detail',
  /** ページガイド: タイムライン */
  PAGE_TIMELINE: 'page_timeline',
  /** ページガイド: マイページ */
  PAGE_PROFILE: 'page_profile',
  /** メニューナビゲーションガイド */
  MENU_NAVIGATION: 'menu_navigation',
} as const;

/** localStorage キー（一時的なUI非表示用） */
export const TUTORIAL_LOCAL_KEYS = {
  BANNER_DISMISSED: 'tutorial:banner_dismissed',
  PULSE_SHOWN: 'tutorial:pulse_shown',
  WELCOME_FALLBACK: 'tutorial:welcome_fallback',
  MILESTONE_FIRST_EVENT: 'milestone:first_event',
} as const;

/** ページガイドの定義 */
export const PAGE_GUIDES: Record<string, { title: string; description: string }> = {
  [TUTORIAL_IDS.PAGE_DASHBOARD]: {
    title: 'ダッシュボード',
    description:
      'イベントの概要確認、AIからのおすすめ提案、統計情報をまとめて確認できるホーム画面です。',
  },
  [TUTORIAL_IDS.PAGE_EVENTS]: {
    title: 'イベント一覧',
    description:
      '作成・参加しているイベントをフィルターや並び替えで管理できます。',
  },
  [TUTORIAL_IDS.PAGE_EVENT_DETAIL]: {
    title: 'イベント詳細',
    description:
      'イベントの共有リンク発行、参加者の確認、コメントのやりとり、編集・複製ができます。',
  },
  [TUTORIAL_IDS.PAGE_TIMELINE]: {
    title: 'タイムライン',
    description:
      '主催・参加イベントを時系列で一覧できます。フィルターで絞り込みも可能です。',
  },
  [TUTORIAL_IDS.PAGE_PROFILE]: {
    title: 'マイページ',
    description:
      'プロフィール編集、プラン確認、興味や通知の設定ができます。各項目をタップすると編集できます。',
  },
};

/** ウェルカムストーリーのスライドコンテンツ */
export const WELCOME_SLIDES = [
  {
    id: 'greeting',
    title: 'はじめまして、{name}さん！',
    lines: [
      'わたしたち、企画苔の案内役の',
      '苔親子（こけおやこ）。',
      '一緒にはじめましょう',
    ],
  },
  {
    id: 'features',
    title: '企画苔でできること',
    features: [
      {
        icon: 'sparkles' as const,
        label: 'AIに相談して企画をつくる',
        description: '3つの質問に答えるだけで、AIがぴったりの企画を提案',
      },
      {
        icon: 'link' as const,
        label: 'リンクひとつでみんなを招待',
        description: 'アカウント不要。リンクを送るだけでゲストが参加できる',
      },
      {
        icon: 'calendar' as const,
        label: '日程も出欠もまるっと管理',
        description: '日程調整から参加確認まで、これひとつで完結',
      },
    ],
  },
  {
    id: 'start',
    title: '準備完了！',
    lines: ['まずはAIと一緒に', '最初のイベントを企画してみましょう'],
  },
] as const;
